import { Box, Button, TextField, InputAdornment, IconButton, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const Login = ({ setLogIn, setActiveMenuItem}) => {

  useEffect(() => {
    setActiveMenuItem('login')
  }, []);

  const email = process.env.REACT_APP_EMAIL;
  const password = process.env.REACT_APP_PASSWORD;
  const expirationDate = new Date().getTime() + (24 * 60 * 60 * 1000);

  const [loginError, setLoginError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate()
  const handleFormSubmit = (values) => {
    console.log(values);
    if (values.email.toLowerCase() === email && values.password === password) {
      localStorage.removeItem('userEcommerce');
      localStorage.removeItem('expirationDateEcommerce');

      // Store the user data in local storage
      localStorage.setItem('userEcommerce', JSON.stringify(values));
      localStorage.setItem('expirationDateEcommerce', expirationDate);
      setLogIn(true);
      navigate("/")
      window.location.reload();
    }
    else {
      setLoginError(true);
    }
  };

  const handleInputChange = (event) => {
    // Clear the login error when email or password is changed
    setLoginError(false);
    // Handle other input changes if needed
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle password visibility
  };

  return (
    <section className="checkout1" >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h6 className="coupon__link">
              <span className="icon_lock-open"></span> Connectez-vous à votre compte.
            </h6>
          </div>
        </div>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          padding={2}
        >

          <Box
            width={isNonMobile ? "400px" : "100%"}
            mt={3}

            borderRadius="8px"
            boxShadow="0px 2px 6px rgba(0, 0, 0, 0.23)"
            padding={3}
          >
            <Formik
              onSubmit={handleFormSubmit}
              initialValues={initialValues}
              validationSchema={checkoutSchema}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box display="grid" gap={2}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      type="text"
                      label="E-mail"
                      onBlur={handleBlur}
                      onChange={(e) => { handleInputChange(e); handleChange(e); }}
                      value={values.email}
                      name="email"
                      error={!!touched.email && !!errors.email}
                      helperText={touched.email && errors.email}
                    />
                    <TextField
                      fullWidth
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      label="Mot de passe"
                      onBlur={handleBlur}
                      onChange={(e) => { handleInputChange(e); handleChange(e); }}
                      value={values.password}
                      name="password"
                      error={!!touched.password && !!errors.password}
                      helperText={touched.password && errors.password}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleTogglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  {loginError && (
                    <Box mt={1} color="red" textAlign="center" bgcolor="#fce6e6" borderRadius="4px" p={2} boxShadow="0px 2px 6px rgba(0, 0, 0, 0.1)">
                      <Typography variant="body2" color="red">
                        Email ou mot de passe incorrect.
                      </Typography>
                    </Box>
                  )}
                  <Box mt={3} display="flex" justifyContent="center">
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      startIcon={<LoginIcon />}
                      style={{
                        fontSize: '14px',
                        color: '#ffffff',
                        background: '#ca1515',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        padding: '14px 30px 15px',
                        borderRadius: '50px',
                        fontFamily: '"Montserrat", sans-serif',
                      }}
                    >
                      Login
                    </Button>
                  </Box>

                </form>
              )}
            </Formik>
          </Box>
        </Box>
      </div>
    </section>
  );
};

const checkoutSchema = yup.object().shape({
  email: yup.string().required("Veuillez saisir une adresse e-mail valide"),
  password: yup.string().required("Veuillez saisir un mot de passe valide"),
});
const initialValues = {
  email: "",
  password: "",
};

export default Login;
